import { COMMENT_TYPE } from "../constants";

const commentReducer = (state = {
   listConversation: [],
   page: 1,
   page_size: 0,
   total: 0
}, action) => {
   switch (action.type) {
      case COMMENT_TYPE.FETCHS:
         return {
            ...state,
            ...action.payload
         };
      case COMMENT_TYPE.ADD:
         return state;
      case COMMENT_TYPE.FETCHS_MORE:
         return {
            ...state,
            listConversation: [...state.listConversation, ...action.payload.listConversation]
         }
      default:
         return state;
   }
};

export default commentReducer